// Modules
import React, { ReactNode } from 'react'
import { ThemeProvider } from '@dasa-health/alma-react'

// Components
import { navTheme } from 'theme'
import { SnackbarProvider } from 'redesign/context/snackbar'
import { CustomSnackbar } from 'redesign/components/molecules/CustomSnackbar'

import { ContainerContent, ContainerPage, StyledContainer } from './styles'

interface TemplateContainerProps {
    children: ReactNode
}

export const MobileServiceTemplate = ({ children }: TemplateContainerProps) => (
    <SnackbarProvider>
        <StyledContainer>
            <ContainerContent>
                <ContainerPage>{children}</ContainerPage>
            </ContainerContent>
            <ThemeProvider theme={navTheme}>
                <CustomSnackbar />
            </ThemeProvider>
        </StyledContainer>
    </SnackbarProvider>
)
